const defaultStatus = {
  key: null,
  color: '#ededed'
};

export const objectHelpers = {
  allValuesEmpty: (obj) => Object.values(obj).every(val => val === null || val === undefined || val === ''),
  arraysIsEqual: (arr1, arr2) => {
    try {
      return JSON.stringify(arr1) === JSON.stringify(arr2)
    } catch (e) {
      return false
    }
  },
  getObjProp: (obj, propName, defaultValue = '') => {
    if (obj && obj.hasOwnProperty(propName)) {
      return obj[propName]
    } else {
      return defaultValue
    }
  },
  getOptionLabel: (options = [], value) => value !== null && value !== undefined ? options.find(o => o.value === value)?.label ?? '-' : undefined,
  getStatus: (statusKey, statusType) => statusType.hasOwnProperty(statusKey) ? statusType[statusKey] : defaultStatus,
  isEmptyObject: (obj) => objectHelpers.arraysIsEqual(obj, {}),
  isEmptyQuery: (query) => query ? !Boolean(Object.keys(query).filter(key => query[key] && query[key].length).length) : true,
  isNaV: (value) => [null, undefined].includes(value),
  isValidValue: (value) => value !== undefined && value !== null && value !== '',
  range: (start, end) => (new Array(end - start + 1)).fill(undefined).map((_, i) => i + start),
  trimAllValues: (fields = {}) => {
    return Object.keys(fields).reduce((acc, key) => {
      const value = fields[key];
      acc[key] = typeof value === 'string' ? value.trim() : value;
      return acc;
    }, {});
  },
  omitInvalidValues: (obj) => Object.fromEntries(Object.entries(obj).filter(([_, value]) => objectHelpers.isValidValue(value))),
  getSearchParams: (searchParams) => {
    const paramsObject = {};

    const parseValue = (value) => {
      if (!isNaN(value) && value.trim() !== "") {
        return value.includes('.') ? parseFloat(value) : parseInt(value, 10);
      }
      return value;
    };

    searchParams.forEach((value, key) => {
      const parsedValue = parseValue(value);

      if (paramsObject[key]) {
        // If key already exists, convert it to an array (if not already) and add the new value
        paramsObject[key] = Array.isArray(paramsObject[key])
          ? [...paramsObject[key], parsedValue]
          : [paramsObject[key], parsedValue];
      } else {
        // If key doesn't exist, just assign the parsed value
        paramsObject[key] = parsedValue;
      }
    });

    return paramsObject;
  },
  removeKeysFromObject: (obj, excludeKeys) => Object.fromEntries(Object.entries(obj).filter(([key]) => !excludeKeys.includes(key))),

  areAllRequiredFieldsFilled: (obj, requiredFields = []) => {
    if (!Array.isArray(requiredFields)) {
      throw new Error('requiredFields must be an array');
    }
    return requiredFields.every(field => obj.hasOwnProperty(field) && obj[field] !== undefined && obj[field] !== null && obj[field] !== '');
  }
}
